export default __webpack_public_path__ + "login-image.png?f2164acd";